import { useEffect } from "react";

const billdeskSdkValues = () => {
  switch (window?.location?.host) {
    case "creditlifeconnect.ageasfederal.com": {
      return {
        0: "https://pay.billdesk.com/jssdk/v1/dist/billdesksdk/billdesksdk.esm.js",
        1: "https://pay.billdesk.com/jssdk/v1/dist/billdesksdk.js",
        2: "https://pay.billdesk.com/jssdk/v1/dist/billdesksdk/billdesksdk.css"
      };
    }
    default: {
      return {
        0: "https://uat1.billdesk.com/merchant-uat/sdk/dist/billdesksdk/billdesksdk.esm.js",
        1: "https://uat1.billdesk.com/merchant-uat/sdk/dist/billdesksdk.js",
        2: "https://uat1.billdesk.com/merchant-uat/sdk/dist/billdesksdk/billdesksdk.css"
      };
    }
  }
};

const useBilldeskScriptLoader = () => {
  const sdkValues = billdeskSdkValues();
  useEffect(() => {
    const esmScript = document.createElement("script");
    esmScript.type = "module";
    esmScript.src = sdkValues?.[0];
    document.body.appendChild(esmScript);

    const nomoduleScript = document.createElement("script");
    nomoduleScript.setAttribute("nomodule", "");
    nomoduleScript.src = sdkValues?.[1];
    document.body.appendChild(nomoduleScript);

    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = sdkValues?.[2];
    document.head.appendChild(link);

    return () => {
      document.body.removeChild(esmScript);
      document.body.removeChild(nomoduleScript);
      document.head.removeChild(link);
    };
  }, []);

  return null;
};

export default useBilldeskScriptLoader;
